import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const map: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M4-12q.106 0 .172.078.077.066.078.172v11.5q-.001.159-.125.219l-3.75 2A.3.3 0 0 1 .25 2a.24.24 0 0 1-.172-.078A.2.2 0 0 1 0 1.75v-11.5q0-.154.14-.219l3.75-2A.2.2 0 0 1 4-12m9.75 0q.106 0 .172.078.076.066.078.172v11.5q-.001.159-.125.219l-3.75 2A.3.3 0 0 1 10 2a.24.24 0 0 1-.172-.078.2.2 0 0 1-.078-.172v-11.5q0-.154.14-.219l3.75-2a.2.2 0 0 1 .11-.031M5-12a.5.5 0 0 1 .11.016l4 2q.14.081.14.234v11.5q0 .106-.078.172A.22.22 0 0 1 9 2a.4.4 0 0 1-.11-.016l-4-2.015q-.14-.077-.14-.219v-11.5c0-.07.023-.129.078-.172.05-.05.11-.078.172-.078m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};

export const mapMarker: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.406-5.578Q6-6.17 6-7q-.001-.826-.594-1.406A1.9 1.9 0 0 0 4-9q-.831.002-1.422.594A1.91 1.91 0 0 0 2-7q-.001.831.578 1.422Q3.17-4.998 4-5q.826.001 1.406-.578M8-7q-.002.845-.25 1.39L4.906.454a.95.95 0 0 1-.375.39A1 1 0 0 1 4 1c-.187 0-.367-.055-.531-.156a.94.94 0 0 1-.36-.39L.266-5.61Q-.002-6.155 0-7q0-1.655 1.172-2.828T4-11q1.655 0 2.828 1.172A3.86 3.86 0 0 1 8-7m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "8",
  }
};

export const mapPin: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3-3.625c.32.086.656.125 1 .125q.515.002 1-.125V1.5c0 .133-.055.25-.156.344A.46.46 0 0 1 4.5 2h-1a.5.5 0 0 1-.36-.156A.47.47 0 0 1 3 1.5zm-1.828-7.203Q2.343-12 4-12q1.655 0 2.828 1.172A3.86 3.86 0 0 1 8-8q0 1.657-1.172 2.828A3.86 3.86 0 0 1 4-4Q2.343-4 1.172-5.172 0-6.343 0-8q0-1.655 1.172-2.828M4-10.25q.106 0 .172-.062a.26.26 0 0 0 .078-.188.22.22 0 0 0-.078-.172A.22.22 0 0 0 4-10.75q-1.144.001-1.953.813A2.64 2.64 0 0 0 1.25-8q0 .111.063.188.076.063.187.062.106 0 .172-.062A.26.26 0 0 0 1.75-8q0-.937.656-1.594A2.2 2.2 0 0 1 4-10.25m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "8",
  }
};
